// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// If you have a PRISM_ENV system variable configured, the build system will look for a
// `environment.%PRISM_ENV.ts` environment file, see the project readme.md file for
// more information about the system variable / workstation configuration.

export const environment = {
    production: false,
    firebaseConfig: {
        apiKey: 'AIzaSyB8EeBr-htv9B2uGBON-5-hpb_5k8HpAcY',
        authDomain: 'testyprism.firebaseapp.com',
        databaseURL: 'https://testyprism.firebaseio.com',
        projectId: 'testyprism',
        storageBucket: 'testyprism.appspot.com',
        messagingSenderId: '950190579199'
    },
    functionsUrl: 'https://us-central1-testyprism.cloudfunctions.net/',
    apiUrl: 'https://dev.prismdisplay.com/api',
    apiVersion: 'v1',
    webAppUrl: 'https://app.prismdisplay.com'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts